import {json, type LoaderArgs} from '@shopify/remix-oxygen';
import {Link} from '~/components';
import {CACHE_SHORT, routeHeaders} from '~/data/cache';
import {defaultSizableImage, processArticle} from '~/utils';
import * as Icon from 'react-feather';
import {renderMarkDown} from '~/lib/utils';

export const headers = routeHeaders;

export const loader = async ({request, context}: LoaderArgs) => {
  const {storefront} = context;
  const {language, country} = storefront.i18n;

  const seo = {};

  return json(
    {seo, language, country},
    {
      headers: {
        'Cache-Control': CACHE_SHORT,
      },
    },
  );
};

const ArticleList = ({
  articles,
  language,
  country,
}: {
  articles: any;
  language: string;
  country: string;
}) => {
  return (
    <>
      <div className="blog-area ptb-80">
        <div className="container">
          <div className="row justify-content-center">
            {articles?.map((article: any, idx: number) => {
              const {
                id,
                title,
                media,
                content,
                content_MD,
                author,
                handle,
                createdAt,
                isContentMarkdown,
              } = processArticle(article, language, country);

              return (
                <div
                  className="col-lg-4 col-md-6"
                  key={`${handle}-${id}-${idx}`}
                >
                  <div className="single-blog-post">
                    <div className="blog-image">
                      <Link to={handle}>
                        <img
                          src={
                            media ||
                            defaultSizableImage({
                              title,
                              width: 296,
                              height: 241,
                            })
                          }
                          alt={title}
                        />
                      </Link>

                      <div className="date">
                        <Icon.Calendar />
                        {createdAt}
                      </div>
                    </div>

                    <div className="blog-post-content">
                      <h3>
                        <Link to={handle}>{title}</Link>
                      </h3>
                      <span>
                        By <Link to="/">{author}</Link>
                      </span>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: renderMarkDown(content_MD || ''),
                        }}
                        className="prose blog-card-content"
                      />

                      <Link to={handle} className="read-more-btn">
                        Read More <Icon.ArrowRight />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticleList;
